import loadPreactModule from "../../../../utils/loadPreactModule";

const internalLoader = () => import("./module").then((module) => module.default);

export default function renderer(context) {
    return loadPreactModule("RiverNotificationItem", context, {}, internalLoader);
}
